<template>
  <div
    :class="
      'i-table item-' +
      item.item.idRisorsa +
      ' ' +
      (selectable && !isSelected ? 'selectable' : '')
    "
    v-on:click="cell_Click"
    :showCellHover="showCellHover"
    :isSelected="isSelected"
    :selectable="selectable"
  >
    <draggable
      :class="'item-' + item.item.idRisorsa"
      style="height: auto; min-height: 40px"
      draggable=".draggable-event"
      :handle="'.item-' + item.item.idRisorsa"
      @start="cell_Drag"
      @end="cell_Drop"
      @change="cell_Change"
      v-model="localEvents"
      :clone="event_Clone"
      :group="{ name: 'events'+item.item.idRisorsa, pull: pullFunction }"
    >
      <v-hover
        v-slot="{ hover }"
        open-delay="300"
        close-delay="2000"
        v-for="event in localEvents"
        :key="event.idIntervento"
        :ev-type="event.tipo"
      >
          <v-btn :id="event.idIntervento"
                 tile
                 v-if="event != null"
                 :ev-type="event.tipo"
                 v-on:click="btn_Click(event)"
                 :style="GetBtnStyle(event, hover)"
                 :class="
            'event slide-hover i-event  text-left ' +
            GetBtnClass(event) +
            ' ' +
            (hover ? 'hover' : '') +
            ' ' +
            (event.isCreator && allowDragAndDrop && event.tipo==EventType.Intervento ? 'draggable-event' : '')
          ">
              <div class="event-customer" v-if="event.cliente != null && event.tipo==EventType.Intervento">
                  {{ event.cliente.descrizione }}
              </div>
              <div class="event-description" v-if="event.sede != null && event.tipo==EventType.Intervento" >
                  {{ event.sede.citta }}({{event.sede.provincia}}) - {{event.sede.indirizzo}}
              </div>
              <div class="event-description" v-if="event.tipo!=EventType.Intervento" >
                  {{ event.descrizione }}
              </div>
          </v-btn>
      </v-hover>
    </draggable>
  </div>
</template>


 <style lang="scss">
.event-customer {
  font-size: 14px;
  font-weight: bold;
}

.event.hover {
  transition: width 500ms, height 4s;
  width: 100% !important;
}
.event {
  transition: width 1000ms, height 4s;
}
.event-description {
  font-size: 10px;
  text-transform: full-size-kana;
}
.operator-day-cells[isselected="true"] {
  background: lightblue !important;
}
.operator-day-cells[isselected="true"]:hover {
  background: transparent !important;
}
// td.operator-day-cells:hover {
//   background: lightblue !important;
// }
// i-table:hover{
//   background: #eee;
// }
.i-table {
  height: auto;
  min-height: 100%;
}
.i-event {
  display: inline-block;
  width: 50%;
  padding: 3px !important;
  margin: 1px 1px 1px 1px !important;
  background: #a00;
  color: white;
  vertical-align: top;
  border: 0px;
  height: 100% !important;
}
.i-event span.v-btn__content {
  text-align: left;
  overflow: hidden;
  display: block;
  color: white;
  padding-left: 3px;
}
.selectable {
  background: #fbfbfb;
}
.i-table[showCellHover="true"]:hover {
  background: lightblue;
}
</style> 
<script>
import draggable from "vuedraggable";
import moment from "moment";
import EventType from "../../settings/EventType"; //"../../../settings/EventType";

var Shared = { Copy: false, EventId: 0 };
export default {
  props: {
    allowDragAndDrop: { default: true },
    showCellHover: { default: true },
    events: {
      default: null,
    },
    selectable: { default: false },
    item: { default: null },
    date: { default: null },
    selectedItems: { default: [] },
  },
  data: () => ({
    lastEventClick: new Date(),
    arr: [],
    EventType:EventType,
    drag: false,
    localEvents: [],
    clone: false,
    controlOnStart: false,
  }),
  created() {
    let currUser = JSON.parse(localStorage.currentUser);

    this.localEvents = this.events;
    for (let i = 0; i < this.localEvents.length; i++) {
      this.localEvents[i].isCreator = this.isEventCreator(
        this.localEvents[i],
        currUser
      );
    }
  },
  watch: {
    isSelected(newVal) {
      this.$el.parentNode.setAttribute("isselected", newVal);
    },
    events(newv, old) {
      let currUser = JSON.parse(localStorage.currentUser);
      this.localEvents = newv;

      for (let i = 0; i < this.localEvents.length; i++) {
        this.localEvents[i].isCreator = this.isEventCreator(
          this.localEvents[i],
          currUser
        );
      }
    },
  },
  components: { draggable },
  methods: {
    isEventCreator(ev, currUser) {
      let canEditOtherEvents = false;
      let p = currUser.ruolo.permessi.find(
        (p) => p.idPermesso == "MANAGE_OTHER_USER_EVENTS"
      );
      if (p != undefined) {
        canEditOtherEvents = p.abilitato;
      }

      // console.debug("ev.idCreatore ",ev.idCreatore  );
      // console.debug("currUser.idUtente",  currUser.idUtente);
      // console.debug("  ev.idCreatore == currUser.idUtente",ev.idCreatore == currUser.idUtente);
      return canEditOtherEvents || ev.idCreatore == currUser.idUtente;
    },
    event_Clone(el) {
      if (Shared.Copy) {
        console.debug("CLONEEEEEEEEEEEEEEEEEEEE", el);
        Shared.EventId = el.idIntervento;
        // el.idIntervento = 0;
      }
      return el;
    },
    pullFunction() {
      return Shared.Copy ? "clone" : true;
    },
    cell_Drag({ originalEvent }) {
      Shared.Copy = originalEvent.ctrlKey;
      // this.controlOnStart =
      console.debug("drag e", originalEvent);
      console.debug("SHARED", Shared);
    },
    cell_Change(e) {
        console.debug("SHARED", Shared);
        console.debug("CHANGEDD", this.date, e);
        if (e.added != undefined) {
          //CAMBIO DATA
          let ev = e.added.element;
          let old = { ...ev };

          let oldDate = moment(ev.inizio).format("YYYY-MM-DD");
          let newDate = moment(this.date.date).format("YYYY-MM-DD");
          console.debug("oldDate", oldDate);
          console.debug("newDate", newDate);
          let oraInizio = moment(ev.inizio).format("HH:mm:00.000");
          let oraFine = moment(ev.fine).format("HH:mm:00.000");
          let inizio = newDate + "T" + oraInizio;
          let fine = newDate + "T" + oraFine;
          // ev.inizio = inizio;
          // ev.fine = fine;
          if (!Shared.Copy) {
            console.debug("MOVEDDDDDDDDDDDDDDDD", e);
            this.$emit("eventMoved", ev, inizio, fine);
          } else {
            console.debug("CLONEDDDDDDDDDDDDDDDD", e);
            ev.idIn;
            this.$emit("eventCloned", ev, inizio, fine);
          }
          Shared.Copy = false;
        }
      
    },
    cell_Drop(e) {
      console.debug("drop e", e);
      // let event = this.events.find((ev) => ev.idIntervento == e.item.id);
    },
    cell_Click(e) {
      if (new Date() - this.lastEventClick > 2000) {
        // console.debug(e.target);
        this.$emit("cellClick", this.date, this.item);
      }
    },
    btn_Click(event) {
      if (event.tipo == EventType.Intervento) {
        this.lastEventClick = new Date();

        this.$emit("eventClick", this.date, this.item, event, event.isCreator);
      } else {
        this.$emit(
          "absenceClick",
          this.date,
          this.item,
          event,
          event.isCreator
        );
      }
    },
    GetBtnStyle(event, hover) {
      //   let itemId = this.GetItemId(day.date, item);
      //   if (this.isSelected)
      //     return "background-color:#1976d2";
      //   else if (this.events.length>0) {
      let st = "";
      if (!event.giornoIntero) {
        let inizio = Date.parse(event.inizio);
        let fine = Date.parse(event.fine);
        let diff = fine - inizio;
        let hours = diff / (1000 * 60 * 60);
        let width = (100 / 24) * hours;
        st += "width:" + width + "%;";
      } else st = "width:100%; ";
      if (event.tipo == EventType.Assenza) {
        st += " background-color: #333;";
      } else {
        //Intervento
        st += " background-color: " + (event.color ? event.color : "#777");
      }
      // if (event.color && event.tipo!=EventType.Assenza) st += " background-color:" + event.color + ";";
      // if(event.tipo==EventType.Assenza) st+= " background-color:#000;";
      // else st += " background-color: #777;";
      return st;
      //   } else return "";
    },
    GetBtnClass(ev) {
      //   let itemId = this.GetItemId(day.date, item);
      let cl = "";
      //   // if (this.selectedItems.find((i) => i.id == itemId) != undefined)
      //   //   return "primary";
      //   if (this.IsEvent(day, item)) {
      // let ev = this.getEvent(day, item);
      // diff -= hours * (1000 * 60 * 60);
      cl += ev.lampeggia == "true" ? "blink  " : " ";
      cl += "event-type-" + ev.tipo;
      return cl;
      //   } else cl += "empty-event";
      //   return cl;
    },
  },
  computed: {
    isSelected() {
      if (this.selectable)
        return (
          this.selectedItems.find((i) => i.id == this.item.id) != undefined
        );
      else return false;
    },
  },
};
</script>

